import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import ImportedPyn from './ImportedPyn';
import MapContainer from '../maps/MapContainer';
import M from 'materialize-css';

function PlaceSearchDetails(props) {
  const [pynObjects, setPynObjects] = useState(false);
  const [pynDiscardedObjects, setPynDiscardedObjects] = useState(false);
  const [currentPyn, setCurrentPyn] = useState(null);
  const [currentAddres, setCurrentAddres] = useState('');
  const { firestore, pyns } = props;

  useEffect(() => {
    M.AutoInit();
    loadPyns();
  });

  const loadPyns = () => {
    if (pyns) {
      let pynObjects1 = [];
      let pynDiscardedObjects1 = [];
      for (var key in pyns) {
        var value = { ...pyns[key] };
        value.id = key;
        if (value.discarded) {
          pynDiscardedObjects1.push(value);
        } else {
          pynObjects1.push(value);
        }
      }
      if ((!pynObjects && !pynDiscardedObjects) || JSON.stringify(pynObjects) !== JSON.stringify(pynObjects1)) {
        setPynObjects(pynObjects1);
        setPynDiscardedObjects(pynDiscardedObjects1);
      }
    } else if (pynObjects) {
      setPynObjects(false);
      setPynDiscardedObjects(false);
    }
  };

  const onClick = (pyn) => {
    setCurrentPyn({ lat: pyn.pyn.latitude, lng: pyn.pyn.longitude });
    setCurrentAddres(pyn.address);
  };

  const renderPyns = (pyns) => {
    if (pyns) {
      let x = pyns.map((pyn, i) => {
        return <ImportedPyn pyn={pyn} onClick={onClick.bind(null, pyn)} updatePynImported={updatePynImported} />;
      });
      return <div className="collection">{x}</div>;
    } else {
      return <p>No pyns...</p>;
    }
  };

  const updatePynImported = (discarded, pynImportedId) => {
    firestore
      .collection('pyns_imported')
      .doc(pynImportedId)
      .set({ discarded: discarded }, { merge: true })
      .then(() => {
        setPynObjects(false);
        setPynDiscardedObjects(false);
      })
      .catch((error) => console.error('ERROR', error));
  };

  const { placeSearch, auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  return (
    <div>
      {placeSearch ? (
        <div className="container section project-details">
          <div className="card z-depth-0">
            <div className="card-content">
              <div className="company-container row valign-wrapper">
                <div className="col s1">
                  <button className="btn-back" onClick={(e) => window.history.back()}>
                    <i className="small material-icons">arrow_back</i>
                  </button>
                </div>
                <div className="col s11">
                  <span className="card-title">{placeSearch.companyName}</span>
                </div>
              </div>
              <hr />
              <div className="col s12">
                <ul className="tabs">
                  <li className="tab col s3">
                    <a className="active" href="#pynsTab">
                      Pyns imported
                    </a>
                  </li>
                  <li className="tab col s3">
                    <a href="#discardedTab">Discarded pyns</a>
                  </li>
                </ul>
              </div>
              <div id="pynsTab" className="col s12">
                <div className="row">
                  <div className="pyns-container col s6">{renderPyns(pynObjects)}</div>
                  <div className="col s6">
                    <MapContainer pyns={pynObjects} center={currentPyn} className="col s6" />
                    <div className="center">{currentAddres}</div>
                  </div>
                </div>
              </div>
              <div id="discardedTab" className="col s12">
                <div className="row">
                  <div className="pyns-container col s6">{renderPyns(pynDiscardedObjects)}</div>
                  <div className="col s6">
                    <MapContainer pyns={pynDiscardedObjects} center={currentPyn} className="col s6" />
                    <div className="center">{currentAddres}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container center">
          <p>Loading pyns...</p>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const placeSearchId = ownProps.match.params.id;
  const placeSearch = state.firestore.data['currentPlaceSearch'];
  const pyns = state.firestore.data['placeSearchPyns'];
  return {
    id: placeSearchId,
    pyns: pyns,
    placeSearch: placeSearch,
    auth: state.firebase.auth,
    firestore: state.firestore,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    { collection: 'placesSearch', doc: props.id, storeAs: 'currentPlaceSearch' },
    {
      collection: 'pyns_imported',
      where: ['psId', '==', props.id],
      storeAs: 'placeSearchPyns',
    },
  ]),
)(PlaceSearchDetails);
